import { memberBenefits } from '@/mocks/site';

export default function MemberBenefitsSection() {
  return (
    <section className="py-20 md:py-28 px-6 bg-background-100">
      <div className="mx-auto" style={{ maxWidth: 1280 }}>
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            会员权益
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            VIP会员专属特权
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            成为VIP会员，解锁六大专属权益，享受更专业、更全面的资源服务
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {memberBenefits.map((benefit) => (
            <div
              key={benefit.id}
              className="flex gap-4 p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${benefit.icon} text-lg`} />
              </div>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5">
                  {benefit.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <a
            href="#"
            className="inline-flex px-8 py-3 rounded-full bg-accent-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-accent-600 transition-all cursor-pointer"
          >
            立即开通VIP
          </a>
        </div>
      </div>
    </section>
  );
}